import traductor from "../../assets/traductor_w.png";
import generador from "../../assets/cuestionador_w.png";
import planificadorsac from "../../assets/PlanSAC_w.png";
import infoEdu from "../../assets/InfoEdu_w.png";
import buscador from "../../assets/buscador_w.png";
import BiblioLB from "../../assets/BiblioLB_w.png";
import dashboard from "../../assets/dashboard_w.png"

export const LOGIN_CAROUSEL_ITEMS = [
  {
    id: "sac",
    title: "Sesiones de Aprendizaje SAC",
    image: planificadorsac,
    description:
      "Diseña sesiones de aprendizaje contextualizadas que conectan el currículo con la realidad del estudiante, integrando competencias, desempeños y situaciones significativas de forma clara y ordenada.",
  },
  {
    id: "buscador",
    title: "Buscador de sesiones",
    image: buscador,
    description:
      "Explora, adapta y reutiliza sesiones de aprendizaje validadas, ahorrando tiempo y fortaleciendo tu práctica docente con experiencias ya estructuradas.",
  },
  {
    id: "repositorio",
    title: "Repositorio de sesiones",
    image: dashboard,
    description:
      "Visualiza un resumen centralizado de todas las sesiones generadas y aquellas que se encuentran en proceso.",
  },
  {
    id: "traductor",
    title: "Traductor",
    image: traductor,
    description:
      "Traduce contenidos educativos de forma rápida y precisa, facilitando el acceso al conocimiento en múltiples idiomas sin perder sentido pedagógico.",
  },
  {
    id: "cuestionarios",
    title: "Generador de cuestionarios",
    image: generador,
    description:
      "Crea cuestionarios alineados a tus objetivos de aprendizaje, con preguntas claras y pertinentes que te ayudan a evaluar de manera eficiente y significativa.",
  },
  {
    id: "resumen-documentos",
    title: "Resumen y cuestionario de documentos",
    image: infoEdu,
    description:
      "Transforma documentos extensos en resúmenes claros y cuestionarios interactivos, ideales para estudiar, reforzar contenidos y promover el pensamiento crítico.",
  },
  {
    id: "biblioteca",
    title: "Biblioteca de Libros Resumidos",
    image: BiblioLB,
    description:
      "Selecciona un libro y accede a su contenido en dos formatos de resumen: breve o completo, además de un cuestionario diseñado para reforzar la comprensión y profundizar en las ideas clave.",
  },
];